import { Type } from '@sinclair/typebox';
import { BaseTxSchema } from './base-tx.js';
export const QuoteBurnFields = {
    operation: Type.Literal('quoteBurn'),
};
export const QuoteBurnTxSchema = Type.Object({
    ...BaseTxSchema.properties,
    ...QuoteBurnFields,
});
//# sourceMappingURL=quote-burn-tx.js.map